import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { isAuthenticatedSelector, userSelector } from '../../selectors/authSelectors';
import { useFetchQDeckUsersQuery } from '../../api/qdeckApi';

const PrivateRoute = ({ children, isAuthenticated, path }) => {
  const user = useSelector(userSelector);
  const { data: qdeckUsers = [], isLoading: areQDeckUsersLoading } = useFetchQDeckUsersQuery(undefined, {
    skip: !isAuthenticated
  });
  const isUserQDeckUser = qdeckUsers.some((qdeckUser) => qdeckUser.email === user.email);

  if (!isAuthenticated) {
    return <Navigate to='/' replace />;
  }

  if (!areQDeckUsersLoading && !isUserQDeckUser && path !== '/unauthorized') {
    return <Navigate to='/unauthorized' replace />;
  }

  return children;
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticatedSelector(state)
});

export default connect(mapStateToProps)(PrivateRoute);
